#formattedView h5 {
    font-size: 1.25em;
}

#viewControls {
    row-gap: 2ch;
    margin-bottom: 1ch;
}

#viewControls label {
    margin-bottom: 0;
}

#formattedView table {
    width: 100%;
}

#questionTable, #questionTable th, #questionTable td {
    border: 1px solid black;
    border-collapse: collapse;
}

#questionTable th, #questionTable td {
    padding-left: 2px;
    padding-right: 2px;
}

#questionTable td:nth-child(1) {
    text-align: center;
}

#questionTable td p, .basicQuestion p {
    margin-bottom: 0;
}

.basicQuestion hr {
    margin-bottom: .75em;
    margin-top: .75em;
}

#printHeader {
    display: none;
}

@media print {
    .topControl, #advancedTop, .nav-tabs, .standardHeader {
        display: none !important;
    }
    #printHeader {
        display: block;
    }
    hr {
        margin: .5rem;
    }
}
